<template>
  <v-container>
    <DialogWidget :dialog.sync="dialog"></DialogWidget>
    <v-row>
      <v-col class="d-flex align-center px-5">
        <h1 class="display-1 font-weight-bold ">
          {{ $t("dashboard.dashboard") }}
        </h1>
        <v-btn
          class="ml-2 flex-shrink-0"
          color="primary"
          v-on:click="dialog = true"
        >
          {{ $t("widgets.add-widget") }}
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <DashboardLayout></DashboardLayout>
      </v-col>
    </v-row>
  </v-container>
</template>
<style scoped></style>
<script>
import { title } from "../components/mixins/title";
import DashboardLayout from "../components/dashboard/DashboardLayout";
import DialogWidget from "../components/dashboard/DialogWidget";
export default {
  mixins: [title],
  components: {
    DashboardLayout,
    DialogWidget
  },
  data: () => ({
    dialog: false
  }),
  methods: {
    getArgumentForTitle() {
      return {
        chain: [this.$t("dashboard.dashboard")]
      };
    }
  }
};
</script>
